module.exports = __webpack_public_path__ + "img/d85591d9-7eed-405b-a0d1-5523882e594f (1).3883ba78.png";